import { render, staticRenderFns } from "./AddTagModal.vue?vue&type=template&id=1bb4125e&"
import script from "./AddTagModal.vue?vue&type=script&lang=js&"
export * from "./AddTagModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports